//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';
import { Normalized } from '@utils/normalize';

export const getOrderedPostDetailsPins = createSelector(
  (state: ICuralateStore) =>
    state.pinterest.postDetails.currentPostDetails.pins,
  (normalizedPins) => Normalized.getOrdered(normalizedPins),
);
